import { xtwhUrls } from '@shared/urls/xtwhUrls';
import { CacheService } from '@delon/cache';
import { Injectable, Injector, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { zip } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MenuService, TitleService, ALAIN_I18N_TOKEN, Menu } from '@delon/theme';
import { DA_SERVICE_TOKEN, ITokenService } from '@delon/auth';
import { ACLService } from '@delon/acl';
import { TranslateService } from '@ngx-translate/core';
import { I18NService } from '../i18n/i18n.service';

import { NzIconService } from 'ng-zorro-antd/icon';
import { ICONS_AUTO } from '../../../style-icons-auto';
import { ICONS } from '../../../style-icons';
import { UserDetailResp } from '@shared/utils/userDetailResp';
import { PublicParams } from '@shared/utils/publicParams';

/**
 * Used for application startup
 * Generally used to get the basic data of the application, like: Menu Data, User Data, etc.
 */
@Injectable()
export class StartupService {
    constructor(
        iconSrv: NzIconService,
        private menuService: MenuService,
        private translate: TranslateService,
        @Inject(ALAIN_I18N_TOKEN) private i18n: I18NService,
        private aclService: ACLService,
        private titleService: TitleService,
        @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService,
        private http: HttpClient,
        private injector: Injector,
        private cacheService: CacheService,
    ) {
        iconSrv.addIcon(...ICONS_AUTO, ...ICONS);
    }

    private viaHttp(resolve: any, reject: any) {
        zip(
            this.http.get(`assets/tmp/i18n/${this.i18n.defaultLang}.json`),
            this.http.get('assets/tmp/app-data.json'),
            // this.http.post('/feather/getSchoolInfo', {})
        )
            .pipe(
                catchError(([langData, appData]) => {
                    resolve(null);
                    return [langData, appData];
                }),
            )
            .subscribe(
                ([langData, appData]) => {
                    // if (appkeyData.err_code === 2000) {
                    //     console.log('学校配置信息', appkeyData);
                    //     this.cacheService.set('appInfo', {
                    //         schoolName: appkeyData.entity.schoolName,
                    //         logoUrl: appkeyData.entity.logoimg,
                    //         topLogoUrl: appkeyData.entity.topimg,
                    //         QRCode: appkeyData.entity.weming,
                    //         version: appkeyData.entity.versiong,
                    //         copyRight: appkeyData.entity.copyright,
                    //         links: appkeyData.entity.links,
                    //         carousel: appkeyData.entity.background
                    //     });
                    // } else {
                    //     this.http.post('/jczy/users/getSchoolInfo', {}).subscribe((response: any) => {
                    //         if (response.err_code === 2000) {
                    //             this.cacheService.set('appInfo', {
                    //                 logoName: response.logoName,
                    //                 copyRight: response.copyRight,
                    //                 schoolName: response.schoolName,
                    //                 ewmName: response.ewmName,
                    //                 version: response.version
                    //             });
                    //         } else {
                    //             this.message.create('error', response.err_msg);
                    //         }
                    //     })
                    // }
                    // Setting language data
                    // const token = window.location.href.search;
                    // if (token) {
                    //     sessionStorage.setItem("c_token", PublicParams.thirdValue);
                    //     // this.success(token);
                    // }
                    // console.log(this.getQueryString('token'));
                    this.translate.setTranslation(this.i18n.defaultLang, langData);
                    this.translate.setDefaultLang(this.i18n.defaultLang);
                    // ACL: Set the permissions to full, https://ng-alain.com/acl/getting-started
                    this.aclService.setFull(true);
                    console.log(PublicParams.cacheUserName);
                    if(PublicParams.cacheUserName) {
                      this.cacheService.get(PublicParams.cacheUserName).subscribe((res: UserDetailResp) => {
                        if (res.role.includes('学生')) {
                          this.menuService.add([
                            {
                              text: '主导航',
                              group: false,
                              hideInBreadcrumb: false,
                              children: [
                                {
                                  text: '网上评教',
                                  icon: 'anticon-trophy',
                                  children: [
                                    {
                                      text: '我的评教',
                                      link: '/student/wdpj.html',
                                    },
                                  ],
                                }
                              ],
                            },
                          ]);
                          return;
                        }
                        if (!res.role.includes('学生') && !res.role.includes('管理员')) {
                          this.http.post(xtwhUrls.getTwoMenu, {}).subscribe((response: any) => {
                            console.log(response);
                            const root: Menu[] = [
                              {
                                text: '主导航',
                                group: false,
                                hideInBreadcrumb: false,
                                children: response,
                              },
                            ];
                            console.log(root);
                            this.menuService.add(root);
                          });
                        }
                      });
                    }
                },
                () => { },
                () => {
                    resolve(null);
                },
            );
    }

    private viaMockI18n(resolve: any, reject: any) {
        this.http.get(`assets/tmp/i18n/${this.i18n.defaultLang}.json`).subscribe(langData => {
            this.translate.setTranslation(this.i18n.defaultLang, langData);
            this.translate.setDefaultLang(this.i18n.defaultLang);

            this.viaMock(resolve, reject);
        });
    }

    private viaMock(resolve: any, reject: any) {
        const tokenData = this.tokenService.get();
        if (!tokenData.token) {
            // todo 验证是否使用cas
            this.injector.get(Router).navigateByUrl('/passport/login');
            resolve({});
            return;
        }
        const app: any = {
            name: `教务系统`,
        };
        // ACL: Set the permissions to full, https://ng-alain.com/acl/getting-started
        this.aclService.setFull(true);
        // Menu data, https://ng-alain.com/theme/menu

        // Can be set page suffix title, https://ng-alain.com/theme/title
        this.titleService.suffix = app.name;

        resolve({});
    }

    load(): Promise<any> {
        // only works with promises
        // https://github.com/angular/angular/issues/15088
        return new Promise((resolve, reject) => {
            // http
            this.viaHttp(resolve, reject);
            resolve(null);
            // mock：请勿在生产环境中这么使用，viaMock 单纯只是为了模拟一些数据使脚手架一开始能正常运行
            // this.viaMockI18n(resolve, reject);
        });
    }
}
